<div class="master-modal reviepw_items_modal" role="dialog">
    <div class="modal-dialog">
      <!-- Modal content-->
      <div class="modal-content">
        <!-- Modal-Header -->
        <div class="modal-header">
          <h4 class="modal-title">Change Order Status</h4>
          <div class="modal_close_btn">
            <span (click)="dialogClose()" class="modal-close"><i class="material-icons">close</i></span>
          </div>
        </div>
        <form [formGroup]="changeStatusForm" (ngSubmit)="updateStatus()">
          <!-- Modal content-->
          <perfect-scrollbar class="modal-body-scrollbar">
            <div mat-dialog-content>
              <!-- Modal-Body -->
              <div class="modal-body">
                <div class="oreder_status_change">
                  <div class="" fxLayout="row" fxLayout.xl="row" fxLayout.lg="row" fxLayout.md="row" fxLayout.sm="row"
                    fxLayout.xs="column" fxLayoutAlign="start stretch" fxLayoutGap="0px">
                    <div fxLayout="column" fxFlex.xl="100" fxFlex.lg="100" fxFlex.md="100" fxFlex.sm="100" fxFlex.xs="100"
                      fxFlexFill>
                      <!-- TABS -->
                      <div class="custom-tabs">
                        <mat-button-toggle-group formControlName="status"
                          class="horizontal-toggle-buttons tabs-button-group">
                          <mat-button-toggle value="APPROVED">
                            <span class="mat-button-content"> Approved </span>
                          </mat-button-toggle>
                          <mat-button-toggle value="PARTIALLY_SHIPPED">
                            <span class="mat-button-content"> Partially Shipped </span>
                          </mat-button-toggle>
                          <mat-button-toggle value="SHIPPED">
                            <span class="mat-button-content"> Shipped </span>
                          </mat-button-toggle>
                          <mat-button-toggle value="DELIVERED">
                            <span class="mat-button-content"> Delivered </span>
                          </mat-button-toggle>
                          <mat-button-toggle value="CANCELLED">
                            <span class="mat-button-content"> Cancelled </span>
                          </mat-button-toggle>
                          <mat-button-toggle value="REFUNDED">
                            <span class="mat-button-content"> Refunded </span>
                          </mat-button-toggle>
                        </mat-button-toggle-group>
                      </div>
                      <!-- Add Invoice -->
                      <div class="custom-form-group custom_file_group">
                        <label class="custom-label" for="">Add Invoice<span class="star">*</span></label>
                        <div class="custom-form-control">
                          <app-single-file-upload type="IMAGE"></app-single-file-upload>
                          <mat-error *ngIf="invoice.invalid && ( invoice.dirty || invoice.touched )">
                            <span> Invoice is
                              required</span>
                          </mat-error>
                        </div>
                      </div>
                      <!-- Message-TEXT-AREA-->
                      <div class="custom-form-group">
                        <label class="custom-label fx-display" for="">Order Notes<span class="star">*</span> </label>
                        <div class="custom-form-control">
                          <mat-form-field appearance="outline">
                            <textarea rows="5" cols="5" matInput formControlName="message"
                              placeholder="Enter order notes"></textarea>
                            <mat-error *ngIf="message.invalid && ( message.dirty || message.touched )">
                              <span>Please provide a valid value</span>
                            </mat-error>
                          </mat-form-field>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </perfect-scrollbar>
          <!-- Modal-Footer -->
          <div class="modal-footer">
            <div mat-dialog-actions class="modal_footer">
              <button mat-button (click)="dialogClose()" class="modal-cancel-btn modal-footer-btn">
                <span>Cancel</span>
              </button>
              <button mat-button class="modal-save-btn global-btn modal-footer-btn">
                <span>Save</span>
              </button>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
  